import { render } from "./DynamicAppFeedElement.vue.js?vue&type=template&id=083aebab&scoped=true!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=template&id=083aebab&scoped=true"
import script from "./DynamicAppFeedElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppFeedElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=script&lang=js"

import "./DynamicAppFeedElement.vue.scss?vue&type=style&index=0&id=083aebab&scoped=true&lang=scss!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=style&index=0&id=083aebab&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083aebab"],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppFeedElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "083aebab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('083aebab', __exports__)) {
    api.reload('083aebab', __exports__)
  }
  
  module.hot.accept("./DynamicAppFeedElement.vue.js?vue&type=template&id=083aebab&scoped=true!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppFeedElement.vue?vue&type=template&id=083aebab&scoped=true", () => {
    api.rerender('083aebab', render)
  })

}


export default __exports__